import { render, staticRenderFns } from "./AppDesktop.vue?vue&type=template&id=1fd641b9&scoped=true"
import script from "./AppDesktop.vue?vue&type=script&lang=js"
export * from "./AppDesktop.vue?vue&type=script&lang=js"
import style0 from "./AppDesktop.vue?vue&type=style&index=0&id=1fd641b9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fd641b9",
  null
  
)

export default component.exports